import React from 'react';

import PropTypes from 'prop-types';

import { FileHistoryRowData } from './RowIDData';
import {
  RowData,
  RowDetailTable,
  RowIndex,
  RowMessage,
  Seperator
} from './style';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

export const FileHistoryExpandedRowDetails = ({
  rowData,
  fileRowData,
  selectedFileName,
  handleRowDetail,
  showRowDetail
}) => {
  const { t } = useTranslation();
  return (
    <>
      {rowData.fileStatus !== 'INPROGRESS' && (
        <FileHistoryRowData
          rowData={rowData}
          handleRowDetail={handleRowDetail}
          showRowDetail={showRowDetail}
          selectedFileName={selectedFileName}
        />
      )}
      {showRowDetail && selectedFileName === rowData.fileName && (
        <RowDetailTable status={fileRowData.rowIdStatus}>
          {fileRowData.map((row, index) => (
            <>
              <RowData status={rowData.fileStatus}>
                <RowIndex>{row.rowIndex}</RowIndex>
                <RowMessage>
                  {i18next.exists(row.message)
                    ? t(row.message)
                    : t('INVALID_FIELD')}
                </RowMessage>
              </RowData>
              {index < fileRowData.length - 1 && <Seperator />}
            </>
          ))}
        </RowDetailTable>
      )}
    </>
  );
};

FileHistoryExpandedRowDetails.propTypes = {
  rowData: PropTypes.object,
  fileRowData: PropTypes.object,
  selectedFileName: PropTypes.string,
  handleRowDetail: PropTypes.func,
  showRowDetail: PropTypes.bool
};
